import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-mine',
  templateUrl: './mine.component.html',
  styleUrls: ['./mine.component.css']
})
export class MineComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
  }
  sizeOpt = [
    {value:10,text:'小',cls:'mine-cell-s'},
    {value:20,text:'中',cls:'mine-cell-m'},
    {value:30,text:'大',cls:'mine-cell-l'},
    {value:40,text:'巨',cls:'mine-cell-xl'}]
  densityOpt = [
    {value:0.1,text:'10%'},
    {value:0.25,text:'25%'},
    {value:0.5,text:'50%'},
    {value:0.99,text:'一觸即發'}]
  mines:mine[][] = []
  size = 10
  density = 0.1;
  totalMine = 0;
  flagOnMine = 0;
  cellCls = '';
  timeText = '00:00';
  timeSec = 0;
  isOver = true;
  isReady = false;
  interval = null;
  msg = '';

  items:MineItems[] = []
  lifes:{icon:string,state:boolean}[]
  initGame(){
    //初始化
    this.isReady = false;
    this.isOver = false;
    this.msg = '';
    this.resetLifes();
    this.resetItemCount();
    this.timeCounterStop()
    this.initGrid();    
  }
  resetLifes(){
    this.lifes = Array(3).fill(0).map(x=>{
      return {
        icon:'favorite',
        state:true
      }
    })
  }
  costLife(){
    var l = this.lifes.find(x=>x.state);
    if(l){
      l.state = false;
    }
    return this.lifes.filter(x=>x.state).length>0
  }
  initGrid(){
    this.mines = [];
    for(let y=0;y<this.size;y++){
      var row:mine[] = []
      for(let x=0;x<this.size;x++){
        row.push({isMine:false,text:'',state:'hide',roundCnt:0,exCls:''})
      }
      this.mines.push(row);
    }
    this.cellCls = this.sizeOpt.find(x=>x.value == this.size)?.cls;
  }
  createMine(cx:number,cy:number){
    var totCell = this.size*this.size
    var totMine = totCell*this.density;
    // 再多也要留兩隔空白 第一個開局 第二格結束
    this.totalMine = Math.min(totCell-2, totMine);
    var mineCreated = 0
    while(mineCreated<this.totalMine){
      var x = Math.floor(Math.random()*this.size)
      var y = Math.floor(Math.random()*this.size)
      //第一次點選的那格不產生
      if(x==cx&&y==cy){
        continue;
      }
      if( this.mines[y][x].isMine==true){
        continue;
      }else{
        this.mines[y][x].isMine=true;
        mineCreated++;
      }
    }
    this.scanRoundCount()
    this.isReady = true;
    this.timeCounterStart();
  }
  timeCounterStart(){
    this.interval = setInterval(()=>{
      if(this.isPaused) return;
      this.timeSec++;
      this.timeText = Math.floor(this.timeSec/60).toString().padStart(2,'0')+':'+(this.timeSec%60).toString().padStart(2,'0');
    },1000)
  }
  timeCounterStop(){
    if(this.interval){
      clearInterval(this.interval);
    }  
  }
  setFlag(y:number,x:number,evt:Event){
    evt.preventDefault();
    if(this.isOver || (this.mines[y][x].state != 'hide' && this.mines[y][x].state != 'flag')){
      return;
    }
    if(this.mines[y][x].state == 'flag'){
      this.mines[y][x].state = 'hide'
      if(this.mines[y][x].isMine){
        this.flagOnMine--
      }
    }else{
      this.mines[y][x].state = 'flag';
      if(this.mines[y][x].isMine){
        this.flagOnMine++
      }
    }
  }
  openMine(y:number,x:number){
    if(this.isOver){
      return;
    }
    //首次點擊
    if(!this.isReady){
      this.createMine(x,y)
    }
    //超出邊界
    if(y<0 || x<0 || y==this.size||x==this.size ||this.mines[y][x].state!='hide'){
      return;
    }
    if(this.checkBomb(x,y)){
      return;
    }
    this.mines[y][x].state = 'open'
    var roundCount = this.mines[y][x].roundCnt
    if(roundCount==0){
      this.openMine(y-1,x-1)
      this.openMine(y-1,x)
      this.openMine(y-1,x+1)
      this.openMine(y,x-1)
      this.openMine(y,x+1)
      this.openMine(y+1,x-1)
      this.openMine(y+1,x)
      this.openMine(y+1,x+1)
    }else{
      this.mines[y][x].text = roundCount.toString();
    }
    this.checkComplete()
  }
  scanRoundCount(){
    for(let cy=0;cy<this.mines.length;cy++){
      var row = this.mines[cy];
      for(let cx=0;cx< row.length;cx++){
        //if(row[cx].state == 'hide'){
          var cnt = this.getRoundCount(cx,cy)
          row[cx].roundCnt = cnt;
          row[cx].text = (cnt||'').toString();
          row[cx].icon = cnt == 0?Math.random()>0.8?'f':'g':''
        //}
      }
    }
  }
  getRoundCount(x:number,y:number){
    var roundCount = 0
    for(let cy=y-1;cy<=y+1;cy++){
      if(this.mines[cy]){
        for(let cx=x-1;cx<=x+1;cx++){
          if(this.mines[cy][cx]?.isMine){
            roundCount++;
          }
        }
      }
    }
    return roundCount;
  }
  checkBomb(x:number,y:number){
    if(this.mines[y][x].isMine){
      this.mines[y][x].state = 'bomb'
      if(!this.costLife()){
        if(!this.isPaused){
          this.isOver = true;
          // you died
          this.msg = 'You Lose!!!'
          this.timeCounterStop();
        }
      }
      return true;
    }
    return false;
  }
  checkDead(){
    if(this.lifes.filter(x=>x.state).length<=0){
      this.isOver = true;
      // you died
      this.msg = 'You Lose!!!'
      this.timeCounterStop();
    }
  }
  checkComplete(){
    var anySpece = false;
    for(let cy=0;cy<this.size;cy++){
      for(let cx=0;cx<this.size;cx++){
        if(this.mines[cy][cx].state=='hide' && !this.mines[cy][cx].isMine){
          anySpece = true;
          break;
        }
      }
    }
    //點完了
    if(!anySpece){
      this.isOver = true;
      if(this.interval){
        clearInterval(this.interval);
      }
      this.msg = 'You Win!!!'
      for(let cy=0;cy<this.size;cy++){
        for(let cx=0;cx<this.size;cx++){
          if(this.mines[cy][cx].isMine){
            this.mines[cy][cx].state = 'flag'
          }
        }
      }
    }
  }
  resetItemCount(){
    this.items = [];
    this.items.push(new SearchItem(this));
    this.items.push(new ViewItem(this));
    this.items.push(new RearrangeItem(this));
    this.items.push(new RocketItem(this));
  }
  
  isPaused=false;
  pause(){
    this.isPaused = true;
  }
  continue(){
    this.isPaused = false
  }
  show:boolean = false;
  open(){
    this.show = true;
  }
  close(){
    this.show = false;
  }
  playRocket = false;
  rx=0;
  ry=0;
  @ViewChild('rocketDiv')
  rocketDiv:ElementRef<HTMLDivElement>
  rocketTo(a:{x,y},b:{x,y},callback:()=>void){
    this.rocketDiv.nativeElement.style.transition = null;
    this.rocketDiv.nativeElement.style.transform = null;
    this.playRocket = true;
    this.rocketDiv.nativeElement.style.top = a.y +'px';
    this.rocketDiv.nativeElement.style.left = a.x+'px';
    this.rocketDiv.nativeElement.offsetHeight;
    requestAnimationFrame(()=>{
      var rx = b.x - a.x;
      var ry = b.y - a.y;  
      const dx = b.x - a.x;
      const dy = b.y - a.y;
      const angleRad = Math.atan2(-dy, dx); // ← 弧度 (radians)
      const angleDeg = angleRad * 180 / Math.PI; // ← 轉成角度 (degrees)
      this.rocketDiv.nativeElement.style.transition = 'transform 1s cubic-bezier(0.2, 0.6, 0.4, 1)';
      this.rocketDiv.nativeElement.style.transform = `translate(${rx}px,${ry}px) rotate(${-(angleDeg-90)}deg)`;

      const onTransitionEnd = (e: TransitionEvent) => {
        if (e.propertyName === 'transform') {
          this.playRocket = false;
          callback()
          this.rocketDiv.nativeElement.removeEventListener('transitionend', onTransitionEnd);
        }
      };
      this.rocketDiv.nativeElement.addEventListener('transitionend',onTransitionEnd)
    })
  }
}

class mine{
  state:'open'|'flag'|'hide'|'bomb';
  isMine:boolean;
  text:string;
  roundCnt:number;
  exCls:string;
  icon?:string;
}
interface MineItems{
  times:number;
  icon:string;
  desc:string;
  Use(evt:MouseEvent);
}

class SearchItem implements MineItems{
  constructor(private gm:MineComponent) {}
  times = 3;
  icon: string = 'search'
  desc: string = '提示'
  Use(){
    if(this.times==0)return;
    var point:{x:number,y:number,cnt:number}[] = []
    for(let cy=0;cy<this.gm.mines.length;cy++){
      var row = this.gm.mines[cy];
      for(let cx=0;cx< row.length;cx++){
        if(row[cx].state == 'hide' && !this.gm.mines[cy][cx].isMine){
          point.push({x:cx,y:cy,cnt:row[cx].roundCnt});
        }
      }
    }
    for(let cc=0;cc<=8;cc++){
      var pOfCC = point.filter(x=>x.cnt==cc);
      if(pOfCC.length>0){
        var p = pOfCC[Math.floor(Math.random()*pOfCC.length)];
        this.gm.mines[p.y][p.x].exCls = 'tip'
        //this.gm.openMine(p.y,p.x);
        this.times--
        return;
      }
    }
  }
}
class ViewItem implements MineItems{
  constructor(private gm:MineComponent) {}
  times = 3;
  icon: string = 'visibility'
  desc: string = '偷窺'
  Use(evt:MouseEvent){
    if(this.times==0)return;
    var point:mine[] = []
    for(let cy=0;cy<this.gm.size;cy++){
      for(let cx=0;cx<this.gm.size;cx++){
        if(this.gm.mines[cy][cx].state == 'hide' && this.gm.mines[cy][cx].isMine){
          point.push(this.gm.mines[cy][cx]);
        }
      }
    }
    point.forEach(x=>x.state = 'bomb')
    this.gm.pause()
    this.times--
    setTimeout(() => {
      point.forEach(x=>x.state = 'hide')
      this.gm.continue()  
    }, 1000);
  }
}
class RearrangeItem implements MineItems{
  constructor(private gm:MineComponent) {}
  times = 3;
  icon: string = 'change_circle'
  desc: string = '打亂'
  Use(evt:MouseEvent){
    if(this.times==0)return;
    var mineHideCont = 0
    var mineCreated = 0;
    this.gm.pause()
    for(let cy=0;cy<this.gm.size;cy++){
      for(let cx=0;cx<this.gm.size;cx++){
        if(this.gm.mines[cy][cx].state == 'hide' && this.gm.mines[cy][cx].isMine){
          mineHideCont++;
          this.gm.mines[cy][cx].isMine = false;
        }
      }
    }

    while(mineCreated<mineHideCont){
      var x = Math.floor(Math.random()*this.gm.size)
      var y = Math.floor(Math.random()*this.gm.size)
      
      if( this.gm.mines[y][x].isMine==true || this.gm.mines[y][x].state!='hide'){
        continue;
      }else{
        this.gm.mines[y][x].isMine=true;
        mineCreated++;
      }
    }
    this.gm.scanRoundCount()
    this.times--
    this.gm.continue()  
    
  }
}
class RocketItem implements MineItems{
  constructor(private gm:MineComponent) {}
  times = 3;
  icon: string = 'rocket'
  desc: string = 'rocket'
  Use(evt:MouseEvent){
    if(this.times==0)return;
    this.gm.pause()
    this.throwRocket(evt.target as HTMLDivElement,3);
    
    return;
  
  }
  throwRocket(rocket:HTMLDivElement,times:number){
    // 重新計算可用目標
    var point:{x:number,y:number,cnt:number}[] = []
    for(let cy=0;cy<this.gm.mines.length;cy++){
      var row = this.gm.mines[cy];
      for(let cx=0;cx< row.length;cx++){
        if(row[cx].state == 'hide' ){
          point.push({x:cx,y:cy,cnt:row[cx].roundCnt});
        }
      }
    }
    var p = point[Math.floor(Math.random()*point.length)];
    if(p){
      var target = document.getElementById(`mine-${p.y}-${p.x}`)
      this.gm.rocketTo({
        x:rocket.offsetLeft,
        y:rocket.offsetTop
      },{
        x: (target.offsetParent as HTMLElement).offsetLeft+ target.offsetLeft + target.offsetWidth/2 - rocket.offsetWidth/2,
        y: (target.offsetParent as HTMLElement).offsetTop+ target.offsetTop + target.offsetHeight/2 - rocket.offsetHeight/2,
      },()=>{
        this.gm.openMine(p.y,p.x);
        this.gm.openMine(p.y-1,p.x-1)
        this.gm.openMine(p.y-1,p.x)
        this.gm.openMine(p.y-1,p.x+1)
        this.gm.openMine(p.y,p.x-1)
        this.gm.openMine(p.y,p.x+1)
        this.gm.openMine(p.y+1,p.x-1)
        this.gm.openMine(p.y+1,p.x)
        this.gm.openMine(p.y+1,p.x+1)
        if(times>1){
          this.throwRocket(rocket,times-1)
        }else{
          this.times--;
          this.gm.continue();  
          this.gm.checkDead();
        }
      });
    }else{
      this.times--;
      this.gm.continue();  
      this.gm.checkDead();
    }
  }
}